import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorsRoutingModule } from './vendors-routing.module';
import { SharedModule } from '../../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbNavModule, NgbDropdownModule, NgbPaginationModule, NgbHighlight } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
// import { DataTablesModule } from 'angular-datatables';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { AgGridModule } from 'ag-grid-angular';
import { ShipperService } from 'src/app/services/general/shipper.service';
import { ConsigneeService } from 'src/app/services/general/consignee.service';
import { ListVendorComponent } from 'src/app/components/setup/vendors/list/listvendor.component';
import { AddVendorComponent } from 'src/app/components/setup/vendors/add/addvendor.component';
import { EditVendorComponent } from 'src/app/components/setup/vendors/edit/editvendor.component';
import { AddVendorServicesComponent } from 'src/app/components/setup/vendor-services/addvendorservices.component';
import { AccountManagementComponent } from 'src/app/components/setup/vendors/account-management/account-management.component';
import { APIConfigComponent } from 'src/app/components/setup/vendors/api-config/api-config.component';
import { VendorConfigComponent } from 'src/app/components/setup/vendors/vendor-config/vendor-config.component';

@NgModule({
  declarations: [
    ListVendorComponent,
    AddVendorComponent,
    EditVendorComponent,
    AddVendorServicesComponent,
    AccountManagementComponent,
    APIConfigComponent,
    VendorConfigComponent,
  ],
  imports: [
    CommonModule,
    VendorsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgbHighlight,
    NgbNavModule,
    NgbDropdownModule,
    NgSelectModule,
    // DataTablesModule,
    NgbPaginationModule,
    CKEditorModule,
    AgGridModule,
  ],
  exports: [
    ListVendorComponent,
    AddVendorComponent,
    EditVendorComponent,
    AddVendorServicesComponent,
    AccountManagementComponent,
    APIConfigComponent,
    VendorConfigComponent,
  ],
  providers: [
    ShipperService,
    ConsigneeService
  ],
  // schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class VendorsModule { }
